import searchService from '@/services/search.service'
import router from '@/router'

export default {
  async search({ commit, state }, payload = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      // merge filters
      const filters = { ...state.filters, ...payload }
      commit('SET_FILTERS', filters)
      if (!filters?.keywords.length) {
        filters.keywords = filters.searchWithin
      } else {
        filters.keywords = filters.keywords.join(',') + filters.searchWithin
      }


      if (filters.selected.length) {
        filters.searchRefinements = filters.selected.join(',')
      }

      // single
      const singleValues = Object.values(filters.single).filter(Boolean)

      if (singleValues.length) {
        const singleString = singleValues.join(',')

        filters.searchRefinements = filters.searchRefinements
          ? `${filters.searchRefinements},${singleString}`
          : singleString
      }
      // ✅ ADD THIS: update URL
      router.replace({
        query: {
          keywords: filters.keywords,
          selected: filters.selected?.join(','),
          single:  encodeURIComponent(JSON.stringify(filters.single)), // ✅ keep object
          sortKey: filters.sortKey,
          pageNumber: filters.pageNumber,
          pageSize: filters.pageSize,
          searchWithin: filters.searchWithin,
          upc: filters.upc,
          shippingPostalCode: filters.shippingPostalCode,
          searchRefinements: filters.searchRefinements,
          searchNumber: filters.searchNumber
        },
      })    
      let requestFilter = {
        keywords: filters.keywords,
        sortKey: filters.sortKey,
        pageSize: filters.pageSize,
        searchWithin: filters.searchWithin,
        upc: filters.upc,
        shippingPostalCode: filters.shippingPostalCode,
        searchRefinements: filters.searchRefinements,
        pageNumber: filters.pageNumber
      }
      const res = await searchService.search(requestFilter)
      let results = _normalizeResponse(res)

      commit('SET_RESULTS', results)
      commit('SET_MATCHING_PRODUCT_COUNT', res.matchingProductCount)
      commit('SET_PAGINATION', {
        ...state.pagination,
        current_page: parseInt(filters.pageNumber) + 1 || filters.pageNumber,
        numberOfPages: res.numberOfPages > 13 ? 13 : res.numberOfPages,
        total: res.matchingProductCount,
      })
      commit('SET_SEARCH_REFINEMENTS', res.searchRefinements)
      commit('SET_SHOW_DUMMY_DATA', results.length === 0 || _showDummyData(filters))
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return res
    } catch (err) {
      commit('SET_ERROR', err.response?.data || 'Search failed')
      commit('SET_RESULTS', [])
      commit('SET_MATCHING_PRODUCT_COUNT', '100M+')
      commit('SET_SHOW_DUMMY_DATA', true)
      commit('SET_PAGINATION', {
        total: 0,
        current_page: 0,
        last_page: 1,
        numberOfPages: 0
      })
    } finally {
      commit('SET_LOADING', false)
    }
  },


  async getProductDetails({ commit }, asin) {
    commit('SET_LOADING', true)
    const res = await searchService.getProductDetails(asin)
    res.imageUrl = _extractImageUrl(res),
    commit('SET_PRODUCT_DETAILS', res)
    commit('SET_LOADING', false)
    return res
  },
  // change page
  async changePage({ dispatch }, pageNumber) {
    return dispatch('search', { pageNumber })
  },

  // apply filters
  async applyFilters({ dispatch }, filters) {
    return dispatch('search', { ...filters, pageNumber: 0 })
  },

  // reset filters
  async resetFilters({ commit }) {
    commit('RESET_FILTERS')
    commit('SET_SHOW_DUMMY_DATA', true)
    //return dispatch('search')
  },

  async clearAllKeywords({ dispatch, commit }) {
    commit('RESET_KEYWORDS')
    commit('RESET_FILTERS')
    return dispatch('search')
  },

  async addNewKeyword({ dispatch, commit }, keyword) {
    commit('ADD_KEYWORD', keyword)
    return dispatch('search', { pageNumber: 0 })
  },
  
  async removeKeyword({ dispatch, commit }, index) {
    commit('REMOVE_KEYWORD', index)
    return dispatch('search')
  },
  async globalSearch({ commit }, data) {
    const res = await searchService.globalSearch(data)
    commit('SET_GLOBAL_SEARCH', res)
    return res
  },

  async clearMessage({ commit }) {
    commit('SET_MESSAGE', null)
    commit('SET_ERROR', null)
  }

}




function _showDummyData(filters) {
	let filtersValue = filters
	return filtersValue.keywords?.length==0 && filtersValue.selected?.length==0 && Object.keys(filtersValue.single)?.length==0 && !filtersValue.searchRefinements && !filtersValue.shippingPostalCode && !filtersValue.upc && !filtersValue.searchWithin
}

/**
   * 🔄 Normalize response
   */
  function _normalizeResponse(data) {
    return data.products.map((item) => ({
      id: item.id,
      asin: item.asin,
      title: item.title,
      productDescription:item.productDescription,
      productOverview: item.productOverview || {},
      price: item.price?.amount || item.price || item.offerPrice,
      seller: item.seller || item.sellerName,
      manufacturer: item.manufacturerName,
      countryOfOrigin: item.countryOfOrigin,
      imageUrl: _extractImageUrl(item),
      offers: item.includedDataTypes?.OFFERS,
      raw: item,
      unspscTitle: item.taxonomies.find(t => t.type === 'UNSPSC')?.title
    }))
  }

  /**
   * 📸 Extract image URL
   */

  function _extractImageUrl (item) {
    if (!item || typeof item !== 'object') return ''

    const includedImages =
      item.includedDataTypes?.IMAGES ||
      item.includedDataTypes?.images ||
      []

    if (Array.isArray(includedImages) && includedImages.length) {
      const img = includedImages[0]
      if (img && typeof img === 'object') {
        return (
          img.medium?.url ||
          img.large?.url ||
          
          img.original?.url ||
          img.small?.url ||
          img.thumbnail?.url ||
          img.url ||
          ''
        )
      }
    }

    return ''
  }

